// NOTE: this file is for storage runtime variables
// for example, if we want to save is_welcome_dialog_has_show when user enters the website,
// we cannot save in component's state because whole component will unmount when routes changed...
let variables = {
  isWelcomeDialogShown: false
};

export default variables;
